import { useEffect, useState } from "react"
import { type AppConfig } from "@/domain/features/app_config/v2/entities/app_config/app_config"
import { AppConfigRepository } from "@/domain/features/app_config/v2/repositories/app_config/app_config_repository"
import { getFirebaseFirestoreInfra } from "@/infrastructure/firebase_firestore/client"

export const useAppConfig = () => {
  const [appConfig, setAppConfig] = useState<AppConfig | undefined>(undefined)
  useEffect(() => {
    const fetchAppConfig = async () => {
      const firestore = getFirebaseFirestoreInfra()

      const appConfig = await new AppConfigRepository(firestore).fetch()

      setAppConfig(appConfig)
    }

    fetchAppConfig().catch((error) => {
      console.error(error)
    })
  }, [])

  return appConfig
}
